import { render, staticRenderFns } from "./SlotInfoForm.vue?vue&type=template&id=2922f347&scoped=true"
import script from "./SlotInfoForm.vue?vue&type=script&lang=js"
export * from "./SlotInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922f347",
  null
  
)

export default component.exports